// extracted by mini-css-extract-plugin
module.exports = {"avHqlContainer":"_3EPDij","avHqpBanner":"_1tWH01","avUpsellImage":"_3vL-cb"};